const ENV = {
  SERVICE_ID: process.env.REACT_APP_SERVICE_ID,
  TEMPLATE_ID: process.env.REACT_APP_TEMPLATE_ID,
  PUBLIC_KEY: process.env.REACT_APP_PUBLIC_KEY,
  TO_EMAIL: process.env.REACT_APP_TO_EMAIL,
};

export default ENV;
